import { Outlet, Link, useLocation } from 'react-router-dom'
import styles from './Layout.module.css'
import { UpdateToast } from './UpdateToast'
import { APP_VERSION } from '../version'

export function Layout() {
  const location = useLocation()
  const isPlayer = location.pathname === '/player'

  return (
    <div className={styles.layout}>
      <header className={`${styles.header} ${isPlayer ? styles.compact : ''}`}>
        <div className={styles.headerInner}>
          <Link to="/" className={styles.logo} id="nav-logo">
            <div className={styles.logoIcon}>
              <span className={styles.logoSeven}>7</span>
              <span className={styles.logoSeven}>7</span>
              <span className={styles.logoSeven}>7</span>
            </div>
            <div className={styles.logoText}>
              <div className={styles.logoTitleRow}>
                <span className={styles.logoBrand}>AKASH PLAYER</span>
                <span className={styles.versionBadge} title={`Production Version v${APP_VERSION} • Auto-Updated`}>
                  <span className={styles.versionDot} />
                  v{APP_VERSION}
                </span>
              </div>
              <span className={styles.logoTagline}>Video Player</span>
            </div>
          </Link>
          <nav className={styles.nav}>
            <Link to="/" className={`${styles.navLink} ${location.pathname === '/' ? styles.active : ''}`} id="nav-home">Home</Link>
            <Link to="/player" className={`${styles.navLink} ${location.pathname === '/player' ? styles.active : ''}`} id="nav-player">Player</Link>
            <Link to="/download" className={`${styles.navLink} ${location.pathname === '/download' ? styles.active : ''}`} id="nav-download">Download</Link>
            <Link to="/admin" className={`${styles.navLink} ${styles.adminLink}`} id="nav-admin">Admin</Link>
          </nav>
        </div>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <div className={styles.footerBrand}>
            <div className={styles.logoTitleRow}>
              <span className={styles.footerLogo}>AKASH PLAYER</span>
              <span className={styles.versionBadge}>v{APP_VERSION}</span>
            </div>
            <span className={styles.footerTagline}>Paste. Play. Enjoy. • 24/7 Cloudflare Edge</span>
          </div>
          <p className={styles.footerNote}>
            Only public, legally accessible video sources are supported.
            We do not bypass DRM, authentication, or access controls.
          </p>
          <div className={styles.footerLinks}>
            <Link to="/download" id="footer-download">Download App</Link>
            <a href="/sitemap.xml" id="footer-sitemap">Sitemap</a>
            <a href="/robots.txt" id="footer-robots">Robots</a>
          </div>
        </div>
      </footer>

      <UpdateToast />
    </div>
  )
}
